<div class="lineout row main-chats-item">
	<img class="pointer" data-ref="icon">
	<div class="list wide">
		<h2 class="pointer" data-ref="title"></h2>
		<div class="row-compact main-chats-item-user">
			<img data-ref="user-icon">
			<div data-ref="user-name"></div>
		</div>
		<div class="hint" data-ref="messages"></div>
		<button class="lineout fit reset-text" data-ref="memo"></button>
	</div>
	<div class="list main-chats-item-actions">
		<button class="lineout" data-ref="play">play</button>
		<select class="lineout center-text pointer" data-ref="folder"></select>
		<button class="lineout" data-ref="delete">delete</button>
	</div>
</div>
